import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {ChronoCodeLevel} from './ChronoCodeLevel';
import {FreeDataValue} from './FreeDataValue';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class ChronoCode extends BasicEntity {
children: ChronoCode[];
childrenRegex: string;
childrenTimeGapModification: boolean | null;
chronoCodeLevels: {[key: string]: ChronoCodeLevel};
code: string;
color: string;
deletable: boolean | null;
description: TranslatedEmb;
enabled: boolean | null;
endDate: number | null;
externalCode: string;
externalParentCode: string;
freeDataValues: FreeDataValue[];
label: TranslatedEmb;
level: number | null;
nbDays: number | null;
nbHolydays: number | null;
nbSaturdays: number | null;
nbSundays: number | null;
order: number | null;
parentCode: string;
rootCode: string;
startDate: number | null;
}

